import { initializeApp } from 'firebase/app';
import { getAuth, OAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDk7T9kiDMCDX84CgelMgPeVZ7YRA8-FUs",
  authDomain: "ezqna-1ca80.firebaseapp.com",
  projectId: "ezqna-1ca80",
  storageBucket: "ezqna-1ca80.appspot.com",
  messagingSenderId: "246752276394",
  appId: "1:246752276394:web:45bbc093ca4c8a9d4885d3",
  measurementId: "G-ST0NQVDQ72"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Kakao OIDC Provider for Firebase Auth
export const kakaoProvider = new OAuthProvider('oidc.kakao');
kakaoProvider.addScope('profile_nickname');